(function () {
  angular.module('kareo.ui.shared.directives.billing-workflow.focus-input', [])
  .directive('focusInputItem', ['$timeout',
    function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          focusInputItem: '=?'
        },
        link(scope, element, attrs) {
          scope.$watch('focusInputItem', (value) => {
            if (value) {
              $timeout(() => {
                element[0].focus();
              }, 0);
            }
          });
        }
      };
    }]);
})();
